import { basicAxios } from "./basicAxios";

export const makeGetFeatureListDownload = () =>
  basicAxios.get("/api/feature-list", { responseType: "json" });

export const makeUpdateFeatureList = (templates = []) =>
  basicAxios.post("/api/feature-list", { templates });

export const makeGetFeatureLisBlob = () =>
  basicAxios.get("/api/feature-list", { responseType: "blob" });
